import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HomeComponent } from './pages/home/home.component';
import { LoginComponent } from './auth/login/login.component';
import { ResetComponent } from './auth/reset/reset.component';
import { NavComponent } from './common/nav/nav.component';
import { FooterComponent } from './common/footer/footer.component';
import { FullCalendarModule } from '@fullcalendar/angular'; // the main connector. must go first
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin
import interactionPlugin from '@fullcalendar/interaction';
import { ChartsModule } from 'ng2-charts';
import { DiaryComponent } from './pages/diary/diary.component';
import { BarristerDiaryComponent } from './pages/barrister-diary/barrister-diary.component';
import { DatePipe } from '@angular/common';
import { MAT_DATE_LOCALE } from '@angular/material/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { AuthInterceptor } from './service/auth/AuthInterceptors';
import { LayoutModule } from './common/layout.module';
import { NoteModalComponent } from './modal/note-modal/note-modal.component';
import { DocumentModalComponent } from './modal/document-modal/document-modal.component';
import { MeetingModalComponent } from './modal/meeting-modal/meeting-modal.component';
import { DiaryModalComponent } from './modal/diary-modal/diary-modal.component';
import { SettingsComponent } from './pages/settings/settings.component';
import { CompanyComponent } from './pages/company/company.component';
import { TaskModalComponent } from './modal/task-modal/task-modal.component';
import { ConfirmDeleteModalComponent } from './modal/confirm-delete-modal/confirm-delete-modal.component';
import { InvoiceModalComponent } from './modal/invoice-modal/invoice-modal.component';
import { ViewInvoiceModalComponent } from './modal/view-invoice-modal/view-invoice-modal.component';
import { TeamModalComponent } from './modal/team-modal/team-modal.component';
import { ClientModalComponent } from './modal/client-modal/client-modal.component';
import { UserModalComponent } from './modal/user-modal/user-modal.component';
import { NgxDropzoneModule } from 'ngx-dropzone';
import { CourtsComponent } from './pages/courts/courts.component';
import { CourtComponent } from './modal/court/court.component';
import { PopupsComponent } from './modal/popups/popups.component';
import { HolidayModalComponent } from './modal/holiday-modal/holiday-modal.component';
import { AutomationComponent } from './pages/automation/automation.component';
import { TenantListModalComponent } from './modal/tenant-list-modal/tenant-list-modal.component';
import { CookieService } from './service/auth/cookies';




FullCalendarModule.registerPlugins([ 
  dayGridPlugin,
  interactionPlugin
]);

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    LoginComponent,
    ResetComponent,
    NavComponent,
    FooterComponent,
    DiaryComponent,
    BarristerDiaryComponent,
    NoteModalComponent,
    DocumentModalComponent,
    MeetingModalComponent,
    DiaryModalComponent,
    SettingsComponent,
    CompanyComponent,
    TaskModalComponent,
    ConfirmDeleteModalComponent,
    InvoiceModalComponent,
    ViewInvoiceModalComponent,
    TeamModalComponent,
    ClientModalComponent,
    UserModalComponent,
    CourtsComponent,
    CourtComponent,
    PopupsComponent,
    HolidayModalComponent,
    AutomationComponent,
    TenantListModalComponent
  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    LayoutModule,
    CommonModule,
    FormsModule,
    HttpClientModule,
    FullCalendarModule,
    ChartsModule,
    NgxDropzoneModule
  ],
  providers: [
    DatePipe,
    CookieService,
    {provide: MAT_DATE_LOCALE, useValue: 'en-GB'},
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
